import { render, staticRenderFns } from "./SettingsContent.vue?vue&type=template&id=57f64dda&lang=pug&"
import script from "./SettingsContent.vue?vue&type=script&lang=js&"
export * from "./SettingsContent.vue?vue&type=script&lang=js&"
import style0 from "./SettingsContent.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports